import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageFilter'
})
export class MessageFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
  
    
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    let result =  items.filter(item =>
    //  item.lastMessage.toLowerCase().includes(searchText)
    item.isSender == 0 ? item.senderInfo.name.toLowerCase().includes(searchText): item.receiverInfo.name.toLowerCase().includes(searchText)
    );

    return result
  }
}
